<template>
  <div class="human-capitalt-view-past">
    <h2 class="heading-lv2">{{this.ageAverage.year}}年{{this.month}}月期</h2>
    <div class="human-capitalt-data-wrap">
      <div class="human-capitalt-data-wrap__table01">
        <p class="l-formGroup__label u-mb10">平均年齢</p>
        <table class="human-capitalt-data-table">
          <colgroup>
            <col style="width: 16%;">
            <col style="width: 28%;">
            <col style="width: 28%;">
            <col style="width: 28%;">
          </colgroup>
          <thead>
            <tr>
              <th></th>
              <th>正社員</th>
              <th>非正規社員</th>
              <th>全社</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>男性</th>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="ageAverage.regularMaleAgeAverage" :unit="this.unit"/></span>
              </td>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="ageAverage.nonRegularMaleAgeAverage" :unit="this.unit"/></span>
              </td>
              <td>
                <span class="human-capitalt-data-table__text"><strong><Currency :value="ageAverage.achievementMaleAgeAverage" :unit="this.unit"/></strong></span>
              </td>
            </tr>
            <tr>
              <th>女性</th>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="ageAverage.regularFemaleAgeAverage" :unit="this.unit"/></span>
              </td>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="ageAverage.nonRegularFemaleAgeAverage" :unit="this.unit"/></span>
              </td>
              <td>
                <span class="human-capitalt-data-table__text"><strong><Currency :value="ageAverage.achievementFemaleAgeAverage" :unit="this.unit"/></strong></span>
              </td>
            </tr>
          </tbody>
        </table>
      </div><!--/human-capitalt-data-wrap__table01-->
    </div><!--/human-capitalt-data-wrap-->
    <div class="l-contentsGrid2 u-mt30">
      <div class="l-contentsGrid2__item">
        <div>
          <div class="l-formGroup">
            <label class="l-formGroup__label u-mb10">実績に関するメモ</label>
              <p  class="l-text" style="white-space: pre-line;" v-html="repalceLink(ageAverage.resultMemo)"></p>
          </div>
        </div>
      </div>
      <div class="l-contentsGrid2__item">
        <div class="l-contentsMemo">
          <div class="l-formGroup">
            <div class="l-contentsMemo__title">
              <label class="l-formGroup__label">具体的なアクション</label>
            </div>
            <div class="l-contentsMemo__body">
                <div>
                  <p  class="l-text" style="white-space: pre-line;" v-html="repalceLink(ageAverage.actionMemo)"></p>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div><!--/l-contentsGrid2 u-mt30-->
  </div><!--/human-capitalt-data-past-->

</template>

<script>
import Currency from '@/components/parts/human_capital/parts/Currency.vue';

export default {
  components: {
    Currency,
  },
  props: {
    // 表示年度の平均年齢データ
    ageAverage: {},
    month: null,
    num: null,
  },
  data() {
    return {
      unit: '歳',
      unit2:'％',
    }
  },
  computed: {
  },
  watch: {
    ageAverage() {
      this.inputAgeAverage();
    },
  },
  created: function () {

  },
  mounted() {

  },
  methods: {
    inputAgeAverage() {
      this.$emit("change-age-average-detail", {
        ageAverage: this.ageAverage,
        month: this.month,
        num: this.num,
      });
    },
    repalceLink(text) {
      return text ? text.replace(/(https?:\/\/[^\s]*)/g, "<a href='$1'style='text-decoration: underline; color: #0070be;' target='_blank' rel='noopener noreferrer'>$1</a>") : '';
    },

  }
}

</script>
